import { injectIntl } from 'react-intl'
import 'styles/app/inner-layout.scss'
import ListFromTable from 'components/common/ListFromTable'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import messages from './translate'

class JobsWorkflowAdminLayout extends ListFromTable {
  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.jobs),
      showFilterBar: true,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(
      new Column('name', formatMessage(messages.name), {
        sorting: true,
        render: ({ alt }) => alt,
      }),
    )

    return columns
  }

  getActions() {
    const {
      intl: { formatMessage },
      history,
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action('edit', formatMessage(messages.edit), ({ path }) => {
        history.push(path)
      }),
    )

    return actions
  }
}

export default injectIntl(JobsWorkflowAdminLayout)
